import React from "react"
import { TextInput } from "@/components"
import { useFormContext } from "react-hook-form"

function CurrencyInput() {
    const { setValue } = useFormContext()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Remove all non-digit characters
        const onlyNumbers = event.target.value.replace(/[^\d]/g, "")

        if (onlyNumbers === "") {
            setValue("payroll_amount", "0.00")
            return
        }

        // Remove leading zeros
        const trimmedValue = onlyNumbers.replace(/^0+/, "")

        // Ensure value has at least 3 digits (to ensure cents)
        const paddedValue = trimmedValue.padStart(3, "0")

        let integerPart = paddedValue.slice(0, -2)
        const decimalPart = paddedValue.slice(-2)

        // Add comma as thousand separator
        let formattedValue = ""
        while (integerPart.length > 3) {
            formattedValue = `,${integerPart.slice(-3)}${formattedValue}`
            integerPart = integerPart.slice(0, -3)
        }
        formattedValue = `${integerPart}${formattedValue}`

        // Format the value to include the decimal part
        formattedValue += `.${decimalPart}`

        setValue("payroll_amount", formattedValue)
    }

    return (
        <TextInput
            required
            label="Amount per pay period"
            name="payroll_amount"
            data-cy="payroll_amount"
            onChange={handleChange}
            placeholder="0.00"
        />
    )
}

export default CurrencyInput
